<template>
  <vs-dropdown>

    <vs-button class="btn-drop p-2" size="small" type="flat">
      <more-vertical-icon size="2x"></more-vertical-icon>
    </vs-button>

    <vs-dropdown-menu>
      <!--FAQS-->
      <vs-dropdown-item :to="linkToCourseFaq">
        {{ $t('teacher-dash-board.faqs') }}
      </vs-dropdown-item>

      <!--WEB BOARD-->
      <vs-dropdown-item :to="linkToWebBoard">
        {{ $t('teacher-dash-board.web-board') }}
      </vs-dropdown-item>

      <!--CHAT-->
      <!--<vs-dropdown-item to="/myLink">
        {{ $t('teacher-dash-board.chat') }}
      </vs-dropdown-item>-->

      <!--VIRTUAL CLASS EXAMPLE-->
      <vs-dropdown-item :to="linkToVirtualClassExample">
        {{ $t('teacher-dash-board.virtual-class-example') }}
      </vs-dropdown-item>

    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  import {MoreVerticalIcon} from 'vue-feather-icons'

  export default {
    name: "OtherMenuDropdown",
    props: [
      'item'
    ],
    components: {
      MoreVerticalIcon
    },
    computed:{
      linkToCourseFaq(){
        if(this.item){
          let courseOutline, classSection;
          if(this.item.courseOutlineRegistration && this.item.courseOutlineRegistration.courseOutline){
            courseOutline = this.item.courseOutlineRegistration.courseOutline;
            classSection = this.item.classSection;
          }else if(this.item.courseOutline){
            courseOutline = this.item.courseOutline;
            classSection = this.item;
          }
          if(courseOutline && classSection){
            return {
              path: `/course-faq/${classSection.id}/${courseOutline.id}`,
              params: {
                classSectionId: classSection.id,
                courseOutlineId: courseOutline.id,
              },
            };
          }
        }

        return '';
      },
      linkToWebBoard(){
        if(this.item){
          let classSection;
          if(this.item.classSection){
            classSection = this.item.classSection;
          }else if(this.item.courseOutline){
            classSection = this.item;
          }
          if(classSection){
            return {
              path: `/web-board/${classSection.id}`,
              params: {
                classSectionId: classSection.id,
              },
            };
          }
        }

        return '';
      },
      linkToVirtualClassExample(){
        if(this.item){
          let classSection;
          if(this.item.classSection){
            classSection = this.item.classSection;
          }else if(this.item.courseOutline){
            classSection = this.item;
          }
          if(classSection){
            return {
              path: `/e-learning/virtual-class/${classSection.id}`,
              params: {
                classSectionId: classSection.id,
              },
            };
          }
        }

        return '';
      },
    },
  }
</script>

<style scoped>

</style>
